export default __webpack_public_path__ + "static/media/kv-warrior.718a86ed.png";